"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Translate = void 0;
const md5_1 = __importDefault(require("md5"));
const intl_messageformat_1 = __importDefault(require("intl-messageformat"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
class Translate {
    setLanguage(language) {
        this.language = language;
    }
    getLanguage() {
        return this.language;
    }
    setTranslations(translations) {
        this.translations = translations;
    }
    hasTranslations() {
        return (0, isPlainObject_1.default)(this.translations);
    }
    translate(category, message, params = {}) {
        if (!this.hasTranslations()) {
            return this.format(message, params);
        }
        return this.format(this.getTranslatedMessage(category, message), params);
    }
    translateForReact(category, message, params = {}) {
        const translatedMessage = this.translate(category, message, params);
        return (0, html_react_parser_1.default)(translatedMessage);
    }
    format(message, params = {}) {
        try {
            return new intl_messageformat_1.default(message, this.language, undefined, Translate.buildOptions()).format(params);
        }
        catch (e) {
            return message;
        }
    }
    getTranslatedMessage(category, message) {
        const categoryKey = Translate.buildKey(category);
        if (!(categoryKey in this.translations)) {
            return message;
        }
        const messageKey = Translate.buildKey(message);
        const categoryMessages = this.translations[categoryKey];
        return categoryMessages[messageKey] || message;
    }
    static buildKey(key) {
        return (0, md5_1.default)(key);
    }
    static buildOptions() {
        return {
            ignoreTag: true,
        };
    }
}
exports.Translate = Translate;
